import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    appSettings: (config: AxiosRequestConfig) => api.get(`/settings`, config),
};

export default requests;
